import { gql } from 'apollo-angular';

const REMOVE_PERMISSION = gql`
  mutation removePermission($userId: Long!, $permission: UserPermissionType!) {
    removePermission(
      removePermissionRequest: { userId: $userId, permission: $permission }
    ) {
      id
      permissions
    }
  }
`;

export default REMOVE_PERMISSION;
